<style lang="less">
@import "@/styles/drawer-common.less";
</style>

<template>
  <div>
    <Drawer
      title="关于"
      v-model="visible"
      width="450"
      draggable
      :mask-closable="false"
    >
      <div>
      <div> 版本:{{versionText}}</div>
        <div class="drawer-footer br">
          <Button @click="visible = false">确认</Button>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<script>
//import { config } from 'vue/types/umd';

export default {
  name: "about",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      visible: this.value,
      maxHeight: 510,
      submitLoading: false,
      versionText:'',
    };
  },
  methods: {
    changeInputPass(v, grade, strength) {
      this.strength = strength;
    },

    setCurrentValue(value) {
      if (value === this.visible) {
        return;
      }
      this.visible = value;
    },
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
    visible(value) {
      this.$emit("input", value);
    },
  },
  mounted() {
    this.maxHeight = Number(document.documentElement.clientHeight - 121) + "px";
    this.versionText = config.versionText;
  },
};
</script>
